<template>
  <v-menu top :offset-x="true">
    <template v-slot:activator="{ props }">
      <v-btn
        :class="classString"
        @mousedown.stop
        v-bind="props"
        variant="text"
        icon="mdi-dots-vertical"
      >
        <v-icon @mousedown.stop :size="24">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        density="compact"
        v-for="(item, index) in actionDropdown"
        :key="index"
        link
        @click="callAction(item)"
        :disabled="item['disabled']"
        :prepend-icon="item['icon']"
      >
        {{ item['title'] }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>
<script>
export default {
  name: 'ActionMenu',
  props: {
    actionDropdown: { required: true },
    itemIndex: { required: false },
    classString: { required: false },
    size: { type: String, required: false, default: 'small' }
  },
  methods: {
    callAction(item) {
      this.$emit('dialog', item['action'], this.itemIndex)
    }
  }
}
</script>
